import { useTranslation } from 'react-i18next'
import { ChatMessage, SystemEventTypeEnum } from 'types/chat-message'
import { Marker, MarkerContent } from '@/components/ui/marker'

const SYSTEM_MESSAGE_KEYS: Record<SystemEventTypeEnum, string> = {
  [SystemEventTypeEnum.TICKET_CLOSED]: 'systemMessages.TICKET_CLOSED',
  [SystemEventTypeEnum.TICKET_REOPENED]: 'systemMessages.TICKET_REOPENED',
}

export const SystemMessage = ({ messageItem }: { messageItem: ChatMessage }) => {
  const { t } = useTranslation()
  const key = messageItem.systemEventType && SYSTEM_MESSAGE_KEYS[messageItem.systemEventType]
  // Unknown/future system events are hidden by design
  if (!key) return null

  return (
    <Marker variant="separator">
      <MarkerContent>{t(key)}</MarkerContent>
    </Marker>
  )
}
